import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import Translate from 'translate';

import ChannelCaseService from 'services/ChannelCaseService'
import { toggleLoading } from 'stores/actions/';

class LogDetail extends React.Component {

  render() {
    const { data, onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-4"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="logDetail"/></h5>

        {!!data &&
        <div>
          <div className="row">
            <div className="col-md-12">
              <p className="mb-2"><strong><Translate id="content"/>:</strong> {data.content || '---'}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <strong><Translate
                id="attachments"/>:</strong> {!data.attachments || !data.attachments.length ? '---' : ''}
            </div>
            {_.map( data.attachments, item => <div className="col-md-12 ml-2" key={item.id}>
              - <a target="_blank" href={item.webPathFileName}>{item.name || item.fileName}</a>
            </div> )}
          </div>
        </div>
        }
      </Modal>
    )
  }
}

module.exports = LogDetail;




// WEBPACK FOOTER //
// ./routes/app/components/Broadcast/LogDetail/index.js